import React, { useEffect, useState } from "react";
import {
	Row,
	Col,
	Card,
	CardImg,
	CardBody,
	CardText,
	Badge,
	Spinner,
} from "reactstrap";
import "./style.scss";
import { useSelector, useDispatch } from "react-redux";
import location from "assets/images/location.png";
import building from "assets/images/building-icon.png";
import arrow from "assets/images/arrow.png";
import whatsapp from "assets/images/whatsapp.png";
import developerdImg from "assets/images/developer_logo.png";
import "assets/scss/website/app.scss";
import compoundImg from "assets/images/bg.png";
import { useTranslation } from "react-i18next";
import InterestServices from "services/Website/InterestServices";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import { appendFilters } from "store/actions";
import { toast } from "react-toastify";
import { addInterest } from "store/Auth/actions";
import CallModal from "../../CompoundDetails/Modal/CallModal";
import MessageModal from "../../CompoundDetails/Modal/MessageModal";
import Spinner2 from "components/Website/Spinner2";
import ReactWhatsapp from "react-whatsapp";

const UserMode = ({
	developer,
	city,
	address,
	area,
	compound,
	history,
	propertyDetails,
	allUnits,
	setShowInteractive,
}) => {
	const [activeCanvas, setActiveCanvas] = useState(null);
	const [canvas, setCanvas] = useState("");
	const [callModal, setCallModal] = useState(false);
	const [callTypeModal, setCallTypeModal] = useState("");
	const [toolTipData, setToolTipData] = useState("");
	const [phone, setPhone] = useState("");
	const [messageModal, setMessageModal] = useState(false);
	const [unit, setUnit] = useState("");
	const [minSize, setMinSize] = useState(null);
	const [activeCardImg, setActiveCardImg] = useState("");
	const { t } = useTranslation();
	const modeData = useSelector((state) => state.Mode);
	const currency = useSelector((state) => state.Auth?.currency);
	const [openImage, setOpenImage] = useState(0);
	const [noAvailableUnit, setNoAvailableUnit] = useState(null);
	const [interestLoading, setInterestLoading] = useState(false);
	const interestServices = new InterestServices();
	const AuthData = useSelector((state) => state.Auth);
	const dispatch = useDispatch();

	const isInterested = (idData) => {
		const id = parseInt(idData);
		return AuthData.interestsUnits.includes(id);
	};

	const interestHandler = (id) => {
		const data = { unit_id: id };
		setInterestLoading(true);
		if (!AuthData.interestsUnits.includes(id)) {
			interestServices.createInterest(data).then((response) => {
				if (response && response.status === SuccessCreated) {
					toast.success("Unit Added to Your Interests Successfully");
					dispatch(
						addInterest({ interestsUnits: [...AuthData.interestsUnits, id] })
					);
					setInterestLoading(false);
				}
			});
		} else {
			interestServices.deleteInterest(data).then((response) => {
				if (response && response.status === SuccessOk) {
					toast.success("Unit removed from Your interests");
					const updatedInterests = AuthData.interestsUnits.filter(
						(data) => data !== id
					);
					dispatch(addInterest({ interestsUnits: updatedInterests }));
					setInterestLoading(false);
				}
			});
		}
	};

	useEffect(() => {
		document.body.style.overflow = "hidden";
	}, []);

	function toggleFullscreen() {
		setShowInteractive(false);
		document.body.style.overflow = "auto";
	}

	const initCanvas = () => {
		const canvas = new fabric.Canvas(`canvas`);
		canvas.setDimensions({ width: 661.5, height: 398 });
		return canvas;
	};

	useEffect(() => {
		setCanvas(initCanvas());
	}, []);

	useEffect(() => {
		let image = {};
		let updateShapes = [];
		modeData.images.map((img) => {
			if (!!img?.shapes?.length) {
				img?.shapes?.map((res) => {
					if (res?.hotspot?.id === propertyDetails?.id) {
						updateShapes = img?.shapes;
						image = img;
					}
				});
			}
		});
		setActiveCanvas({ ...image, shapes: updateShapes });
	}, [modeData]);

	useEffect(() => setOpenImage(0), [activeCanvas]);

	const renderSavedCanvasData = async (activeCanvas) => {
		let loader = document.getElementById("loader");
		if (canvas !== "") {
			loader.style.display = "block";
			await canvas?.clear();
			await canvas?.renderAll();
			//  myStateRef.current = activeCanvas
			new fabric.Image.fromURL(activeCanvas?.path, function (img) {
				canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
					originX: "left",
					scaleX: canvas.getWidth() / img.width, //new update
					scaleY: canvas.getHeight() / img.height, //new update
					originY: "top",
				});
				loader.style.display = "none";
			});

			fabric.Canvas.prototype.setCursor = function (value) {
				value = "pointer"; // Add your own logic here to override
				this.upperCanvasEl.style.cursor = value;
			};
			if (activeCanvas?.constrains?.type !== "unit") {
				activeCanvas?.shapes?.forEach((shape, index) => {
					if (shape.hotspot?.type === "unit") {
						if (shape.hotspot.data.sale_status === "Left") {
							let shapeData = {
								...shape,
							};
							if (shape.type === "Circle") {
								const text = new fabric.Text(shape?.title, {
									fill: "white",
									left:
										shape.left +
										(shape.aCoords?.tr?.x - shape.aCoords?.tl?.x) / 3,
									top: shape.top - 2,
									// left: shape.left * 1.91,
									// top: shape.top * 2.03 -35,
									fontSize: 16,
									fontWeight: "600",
									type: "text",
									hotspot: {
										type: "none",
									},
								});
								text.set("selectable", false);
								canvas.add(text);

								shapeData = {
									...shape,
									top: shape.top + 20,
									stroke: 0,
								};
								var circle = new fabric.Circle({
									...shapeData,
									fill: "rgba(255,255,255,.4)",
								});
								circle.set("selectable", false);
								// var group = new fabric.Group([circle, text], { ...shapeData })
								canvas.add(circle);
								if (shape?.hotspot?.id === propertyDetails?.id) {
									(function animate(dir) {
										circle.animate(
											{
												opacity: dir ? 1 : 0.4,
											},
											{
												onChange: () => canvas.renderAll(),
												onComplete: function () {
													circle.direction = !circle.direction;
													animate(circle.direction);
												},
												easing: fabric.util.ease.easeOutCubic,
												duration: 700,
											}
										);
									})(circle.direction);
								}
							} else if (shape.type === "Rect") {
								const text = new fabric.Text(shape?.title, {
									fill: "white",
									left: shape.left, // + ((shape.aCoords?.tr?.x - shape.aCoords?.tl?.x) / 2),
									top: shape.top - 18,
									fontSize: 16,
									fontWeight: "600",
									type: "text",
									hotspot: {
										type: "none",
									},
								});
								text.set("selectable", false);
								canvas.add(text);
								shapeData = {
									...shape,
									top: shape.top + 2,
								};
								var rect = new fabric.Rect({
									...shapeData,
									fill: "rgba(255,255,255,.4)",
									stroke: 0,
								});
								rect.set("selectable", false);

								canvas.add(rect);
								if (shape?.hotspot?.id === propertyDetails?.id) {
									(function animate(dir) {
										rect.animate(
											{
												opacity: dir ? 1 : 0.4,
											},
											{
												onChange: () => canvas.renderAll(),
												onComplete: function () {
													rect.direction = !rect.direction;
													animate(rect.direction);
												},
												easing: fabric.util.ease.easeOutCubic,
												duration: 700,
											}
										);
									})(rect.direction);
								}
							} else if (shape.type === "Cubic") {
								const text = new fabric.Text(shape?.title, {
									fill: "white",
									left: shape.left, //+ ((shape.aCoords?.tr?.x - shape.aCoords?.tl?.x) / 2),
									top: shape.top - 5,
									fontSize: 16,
									fontWeight: "600",
									type: "text",
									hotspot: {
										type: "none",
									},
								});
								text.set("selectable", false);
								canvas.add(text);
								shapeData = {
									...shape,
								};
								var rect = new fabric.Rect({ ...shapeData });
								rect.set("selectable", false);

								canvas.add(rect);
								if (shape?.hotspot?.id === propertyDetails?.id) {
									(function animate(dir) {
										rect.animate(
											{
												opacity: dir ? 1 : 0.4,
											},
											{
												onChange: () => canvas.renderAll(),
												onComplete: function () {
													rect.direction = !rect.direction;
													animate(rect.direction);
												},
												easing: fabric.util.ease.easeOutCubic,
												duration: 700,
											}
										);
									})(rect.direction);
								}
							} else if (shape.type === "Pin") {
								const text = new fabric.Text(shape?.title, {
									fill: "white",
									left: shape.left,
									top: shape.top - 7.5,
									fontSize: 16,
									fontWeight: "600",
									type: "text",
									hotspot: {
										type: "none",
									},
								});
								text.set("selectable", false);
								canvas.add(text);

								shapeData = {
									...shape,

									scaleX: shape.scaleX * 0.1,
									scaleY: shape.scaleY * 0.1,
									top: shape.top + 7.5,
								};

								fabric.Image.fromURL(location, function (img) {
									img.scale(0.1).set({
										...shapeData,
									});

									canvas.add(img);
									if (shape?.hotspot?.id === propertyDetails?.id) {
										(function animate(dir) {
											img.animate(
												{
													opacity: dir ? 1 : 0.4,
												},
												{
													onChange: () => canvas.renderAll(),
													onComplete: function () {
														img.direction = !img.direction;
														animate(img.direction);
													},
													easing: fabric.util.ease.easeOutCubic,
													duration: 700,
												}
											);
										})(img.direction);
									}
								});
							} else if (shape.type === "Build") {
								const text = new fabric.Text(shape?.title, {
									fill: "white",
									// left: shape.left * 1.9,
									// top: shape.top * 1.95 -30,
									left: shape.left + 5,
									top: shape.top - 5,
									fontSize: 16,
									fontWeight: "600",
									type: "text",
									hotspot: {
										type: "none",
									},
								});
								text.set("selectable", false);
								canvas.add(text);

								shapeData = {
									...shape,
									// left: shape.left * 1.9,
									top: shape.top + 13,
									scaleX: shape.scaleX * 0.1,
									scaleY: shape.scaleY * 0.1,
								};

								fabric.Image.fromURL(building, function (img) {
									img.scale(0.1).set({
										...shapeData,
									});

									canvas.add(img);
									if (shape?.hotspot?.id === propertyDetails?.id) {
										(function animate(dir) {
											img.animate(
												{
													opacity: dir ? 1 : 0.4,
												},
												{
													onChange: () => canvas.renderAll(),
													onComplete: function () {
														img.direction = !img.direction;
														animate(img.direction);
													},
													easing: fabric.util.ease.easeOutCubic,
													duration: 700,
												}
											);
										})(img.direction);
									}
								});
							} else if (shape.type === "Arrow") {
								const text = new fabric.Text(shape?.title, {
									fill: "white",
									left: shape.left + 10,
									top: shape.top - 5,
									fontSize: 16,
									fontWeight: "600",
									type: "text",
									hotspot: {
										type: "none",
									},
								});
								text.set("selectable", false);
								canvas.add(text);
								shapeData = {
									...shape,
									top: shape.top + 13,
									scaleX: shape.scaleX * 0.065,
									scaleY: shape.scaleY * 0.065,
								};
								fabric.Image.fromURL(arrow, function (img) {
									img.scale(0.065).set({
										...shapeData,
									});

									canvas.add(img);
									if (shape?.hotspot?.id === propertyDetails?.id) {
										(function animate(dir) {
											img.animate(
												{
													opacity: dir ? 1 : 0.4,
												},
												{
													onChange: () => canvas.renderAll(),
													onComplete: function () {
														img.direction = !img.direction;
														animate(img.direction);
													},
													easing: fabric.util.ease.easeOutCubic,
													duration: 700,
												}
											);
										})(img.direction);
									}
								});
							} else {
								shapeData = {
									...shape,
									top: shape.top + 7.5,
								};

								var node = new fabric.Circle({
									...shape,
									radius: 20,
									fill: shape?.fill,
									stroke: shape?.fill,
									strokeWidth: 1,
									top: shape.top + 20,
								});
								const text = new fabric.Text(shape?.title, {
									fill: "white",
									left: shape.left + 3,
									top: shape.top - 5,
									fontSize: 16,
									fontWeight: "600",
									type: "text",
									height: 7.5,
									hotspot: {
										type: "none",
									},
									selectable: false,
								});
								canvas.add(text);
								// var group = new fabric.Group([node, nodeChild], { ...shapeData })
								node.set("selectable", false);

								canvas.add(node);
								if (shape?.hotspot?.id === propertyDetails?.id) {
									(function animate(dir) {
										node.animate(
											{
												opacity: dir ? 1 : 0.4,
											},
											{
												onChange: () => canvas.renderAll(),
												onComplete: function () {
													node.direction = !node.direction;
													animate(node.direction);
												},
												easing: fabric.util.ease.easeOutCubic,
												duration: 700,
											}
										);
									})(node.direction);
								}
							}
						}
					} else {
						let shapeData = {};
						if (shape.type === "Circle") {
							const text = new fabric.Text(shape?.title, {
								fill: "white",
								left:
									shape.left +
									(shape.aCoords?.tr?.x - shape.aCoords?.tl?.x) / 3,
								top: shape.top - 2,
								fontWeight: "600",
								fontSize: 16,
								type: "text",
								hotspot: {
									type: "none",
								},
							});
							text.set("selectable", false);
							canvas.add(text);
							shapeData = {
								...shape,
								fill: "rgba(255,255,255,.4)",
								strokeWidth: 0,
								top: shape.top + 20,
							};

							var circle = new fabric.Circle({ ...shapeData });
							circle.set("selectable", false);
							// var group = new fabric.Group([circle, text], { ...shapeData })
							canvas.add(circle);
							if (shape?.hotspot?.id === propertyDetails?.id) {
								(function animate(dir) {
									circle.animate(
										{
											opacity: dir ? 1 : 0.4,
										},
										{
											onChange: () => canvas.renderAll(),
											onComplete: function () {
												circle.direction = !circle.direction;
												animate(circle.direction);
											},
											easing: fabric.util.ease.easeOutCubic,
											duration: 700,
										}
									);
								})(circle.direction);
							}
						} else if (shape.type === "Rect") {
							const text = new fabric.Text(shape?.title, {
								fill: "white",
								left: shape.left,
								top: shape.top - 18,
								fontSize: 16,
								fontWeight: "600",
								type: "text",
								hotspot: {
									type: "none",
								},
							});
							text.set("selectable", false);
							canvas.add(text);
							shapeData = {
								...shape,
								strokeWidth: 0,
								fill: "rgba(255,255,255,.4)",
								top: shape.top + 2,
							};
							var rect = new fabric.Rect({ ...shapeData });
							rect.set("selectable", false);

							canvas.add(rect);
							if (shape?.hotspot?.id === propertyDetails?.id) {
								(function animate(dir) {
									rect.animate(
										{
											opacity: dir ? 1 : 0.4,
										},
										{
											onChange: () => canvas.renderAll(),
											onComplete: function () {
												rect.direction = !rect.direction;
												animate(rect.direction);
											},
											easing: fabric.util.ease.easeOutCubic,
											duration: 700,
										}
									);
								})(rect.direction);
							}
						} else if (shape.type === "Cubic") {
							const text = new fabric.Text(shape?.title, {
								fill: "white",
								left: shape.left, // + ((shape.aCoords?.tr?.x - shape.aCoords?.tl?.x) / 2),
								top: shape.top - 15,
								fontSize: 16,
								fontWeight: "600",
								type: "text",
								hotspot: {
									type: "none",
								},
							});
							text.set("selectable", false);
							canvas.add(text);
							shapeData = {
								...shape,
								stroke: shape?.fill,
								top: shape.top + 7,
							};
							var rect = new fabric.Rect({ ...shapeData });
							rect.set("selectable", false);

							canvas.add(rect);
							if (shape?.hotspot?.id === propertyDetails?.id) {
								(function animate(dir) {
									rect.animate(
										{
											opacity: dir ? 1 : 0.4,
										},
										{
											onChange: () => canvas.renderAll(),
											onComplete: function () {
												rect.direction = !rect.direction;
												animate(rect.direction);
											},
											easing: fabric.util.ease.easeOutCubic,
											duration: 700,
										}
									);
								})(rect.direction);
							}
						} else if (shape.type === "Pin") {
							const text = new fabric.Text(shape?.title, {
								fill: "white",
								left: shape.left,
								top: shape.top - 11,
								fontSize: 16,
								fontWeight: "600",
								type: "text",
								hotspot: {
									type: "none",
								},
							});
							text.set("selectable", false);
							canvas.add(text);

							shapeData = {
								...shape,
								scaleX: shape.scaleX * 0.1,
								scaleY: shape.scaleY * 0.1,
								left: shape.left,
								top: shape.top + 9,
							};
							fabric.Image.fromURL(location, function (img) {
								img.scale(0.1).set({
									...shapeData,
								});

								canvas.add(img);
								if (shape?.hotspot?.id === propertyDetails?.id) {
									(function animate(dir) {
										img.animate(
											{
												opacity: dir ? 1 : 0.4,
											},
											{
												onChange: () => canvas.renderAll(),
												onComplete: function () {
													img.direction = !img.direction;
													animate(img.direction);
												},
												easing: fabric.util.ease.easeOutCubic,
												duration: 700,
											}
										);
									})(img.direction);
								}
							});
						} else if (shape.type === "Build") {
							const text = new fabric.Text(shape?.title, {
								fill: "white",
								left: shape.left + 10,
								top: shape.top - 8,
								fontSize: 16,
								fontWeight: "600",
								type: "text",
								hotspot: {
									type: "none",
								},
								selectable: false,
							});
							canvas.add(text);
							shapeData = {
								...shape,
								top: shape.top + 13,
								scaleX: shape.scaleX * 0.1,
								scaleY: shape.scaleY * 0.1,
							};
							fabric.Image.fromURL(building, function (img) {
								img.scale(0.1).set({
									...shapeData,
								});

								canvas.add(img);
							});
						} else if (shape.type === "Arrow") {
							const text = new fabric.Text(shape?.title, {
								fill: "white",
								left: shape.left + 10,
								top: shape.top - 5,
								fontSize: 16,
								fontWeight: "600",
								angle: shape.angle,
								type: "text",
								hotspot: {
									type: "none",
								},
							});
							text.set("selectable", false);
							canvas.add(text);
							shapeData = {
								...shape,
								stroke: 0,
								hoverCursor: "cursor",
								// left: shape.left * 1.9,
								top: shape.top + 13,
								// zoomX: shape.zoomX * 2.33,
								// zoomY: shape.zoomY * 2.4125,
								scaleX: shape.scaleX * 0.065,
								scaleY: shape.scaleY * 0.065,
							};
							fabric.Image.fromURL(arrow, function (img) {
								img.scale(0.065).set({
									...shapeData,
								});

								canvas.add(img);
								if (shape?.hotspot?.id === propertyDetails?.id) {
									(function animate(dir) {
										img.animate(
											{
												opacity: dir ? 1 : 0.4,
											},
											{
												onChange: () => canvas.renderAll(),
												onComplete: function () {
													img.direction = !img.direction;
													animate(img.direction);
												},
												easing: fabric.util.ease.easeOutCubic,
												duration: 700,
											}
										);
									})(img.direction);
								}
							});
						} else {
							var node = new fabric.Circle({
								...shape,
								radius: 20,
								fill: shape?.fill,
								stroke: shape?.fill,
								strokeWidth: 1,
								top: shape.top + 20,
							});

							const text = new fabric.Text(shape?.title, {
								fill: "white",
								left: shape.left + 3,
								top: shape.top,
								fontSize: 16,
								fontWeight: "600",
								type: "text",
								hotspot: shape.hotspot,
								selectable: false,
							});
							canvas.add(text);
							node.set("selectable", false);

							canvas.add(node);
							if (shape?.hotspot?.id === propertyDetails?.id) {
								(function animate(dir) {
									node.animate(
										{
											opacity: dir ? 1 : 0.4,
										},
										{
											onChange: () => canvas.renderAll(),
											onComplete: function () {
												node.direction = !node.direction;
												animate(node.direction);
											},
											easing: fabric.util.ease.easeOutCubic,
											duration: 700,
										}
									);
								})(node.direction);
							}
						}
					}
				});
			}
			canvas.renderAll();
		}
	};

	useEffect(() => {
		if (canvas !== "") {
			canvas.on("mouse:over", function (e) {
				let element = document.getElementById("canvas");
				let positionInfo = element.getBoundingClientRect();
				let canvasHeight = positionInfo.height;
				let canvasWidth = positionInfo.width;
				const value = e.target;

				if (value) {
					const tt = document.getElementById("toolTip");
					if (value.type !== "text") {
						if (value?.hotspot?.type == "building") {
							let noAvailableUnit = modeData?.images?.filter(
								(res) => res?.id == value?.idImage?.id
							);

							if (
								noAvailableUnit[0]?.shapes?.some(
									(res) => res?.hotspot?.type == "layer"
								)
							) {
								let ids = noAvailableUnit[0]?.shapes?.map(
									(res) => res.idImage?.id
								);
								let layers = modeData?.images?.filter((res) =>
									ids?.includes(res.id)
								);
								let units = layers?.map((res) => res.shapes);
								setNoAvailableUnit(units?.flatMap((array) => array)?.length);
							}
						}
						if (value.hotspot?.type === "layer") {
							let layer = modeData.images?.filter(
								(img) => img?.id === value?.idImage?.id
							);
							let sizes = layer[0]?.shapes?.map(
								(shape) => shape.hotspot?.data?.size
							);
							setMinSize(sizes);
						}
						setActiveCardImg(value?.idImage?.path);
						setToolTipData(value?.hotspot);

						if (value.hotspot.type === "none") {
							setToolTipData({
								title: value.title,
								...value?.hotspot,
							});
						} else {
							setToolTipData({ ...value?.hotspot, idImage: value?.idImage });
						}
						tt.style.visibility = "visible";
					}

					let left = e.target.left;
					let top = e.target.top;
					let width = Math.abs(value.aCoords.tr.x - value.aCoords.tl.x);
					let height = Math.abs(value.aCoords.tr.y - value.aCoords.br.y);
					let shapeTop = value.aCoords.tl.y * (canvasHeight / 398);
					let shapeLeft = value.aCoords.tr.x * (canvasWidth / 661.5);
					let heightPercent = canvasHeight / 398;
					let widthPercent = canvasWidth / 661.5;

					if (left <= 330) {
						let leftVal = (left + width) * widthPercent;
						tt.style.left = `${leftVal + 20}px`;
					} else {
						let leftVal = left * widthPercent;
						tt.style.left = `${leftVal - 255}px`;
					}
					if (top <= 199) {
						tt.style.top = `${
							top > 99.5 ? shapeTop - 150 : Math.abs(shapeTop - 75)
						}px`;
					} else {
						tt.style.top = `${shapeTop - 340 < 0 ? 20 : shapeTop - 340}px`;
					}
				}
			});
			canvas.on("mouse:out", function (e) {
				const value = e.target;

				if (value) {
					const tt = document.getElementById("toolTip");
					if (e.target) {
						tt.style.visibility = "hidden";
						setNoAvailableUnit(null);
					}
				}
			});
			canvas.on("mouse:down", function (e) {
				const value = e.target;
				if (value) {
					const tt = document.getElementById("toolTip");
					tt.style.visibility = "hidden";

					const navigateTo = value.idImage?.id;
					const canvasTarget = modeData.images.find((item) => {
						return item?.id === parseInt(navigateTo);
					});
					if (!canvasTarget) {
						return;
					}
					let updateShapes;

					if (
						!!canvasTarget?.shapes?.length &&
						canvasTarget?.shapes?.filter(
							(res) => res.hotspot.type == "layer" || res.hotspot.type == "none"
						)?.length > 0
					) {
						updateShapes = canvasTarget?.shapes;
					} else if (canvasTarget?.constrains.type === "building") {
						updateShapes = !!canvasTarget?.shapes?.length
							? canvasTarget?.shapes
							: "";
					} else if (
						!!canvasTarget?.shapes?.length &&
						canvasTarget?.shapes?.some((res) => res.hotspot.type == "unit") &&
						canvasTarget?.shapes?.some((res) => res.hotspot.type == "building")
					) {
						updateShapes = [
							...canvasTarget?.shapes?.filter((res) =>
								allUnits.some((unit) => res.hotspot.units?.includes(unit.id))
							),
							...canvasTarget?.shapes.filter(
								(res) =>
									res.hotspot.type == "unit" &&
									allUnits.some((unit) => res.hotspot.id === unit.id)
							),
						];
					} else {
						updateShapes = !!canvasTarget?.shapes?.length
							? canvasTarget?.shapes?.filter((res) =>
									allUnits.some((unit) => res.hotspot.units?.includes(unit.id))
							  )
							: "";
					}
					setActiveCanvas({ ...canvasTarget, shapes: [...updateShapes] });
				}
			});
		}
	}, [canvas]);

	useEffect(() => {
		renderSavedCanvasData(activeCanvas);
	}, [activeCanvas]);

	return (
		<>
			<Row className="interactive-mode" style={{ overflow: "hidden" }}>
				<Col
					md="12"
					className="my-2 d-flex justify-content-between position-relative"
					style={{ padding: "0 2rem" }}>
					<div>
						{modeData?.masterImg?.id !== activeCanvas?.id && (
							<button
								className="btn btn-light"
								style={{ marginRight: "8px" }}
								onClick={() => {
									const canvasTarget = modeData.images.find((item) => {
										if (!activeCanvas.comesForm?.id) {
											return item?.id === modeData.masterImg?.id;
										}
										return item?.id === activeCanvas.comesForm?.id;
									});
									let updateShapes = [];
									modeData.images.map((img) => {
										if (!!img?.shapes?.length) {
											img?.shapes?.map((res) => {
												if (res?.hotspot?.id === propertyDetails?.id) {
													updateShapes?.push(res);
												}
											});
										}
									});

									setActiveCanvas({
										...canvasTarget,
										shapes: canvasTarget.shapes,
									});
								}}>
								<i className="fas fa-chevron-left"></i>
							</button>
						)}

						{!!propertyDetails?.sales_rep?.phone && (
							<button
								className="btn btnMessage text-center"
								onClick={(e) => {
									e.stopPropagation();
									setCallModal(true);
									if (activeCanvas?.constrains?.type === "unit") {
										setCallTypeModal("unit");
										setPhone(propertyDetails?.sales_rep?.phone);
									} else {
										setCallTypeModal("compound");
										setPhone(propertyDetails?.sales_rep?.phone);
									}
								}}>
								<i className="fas fa-phone-alt"></i>
							</button>
						)}

						<button
							className="btn btnMessage text-center mx-2"
							onClick={(e) => {
								e.stopPropagation();
								if (activeCanvas?.constrains?.type === "unit") {
									setCallTypeModal("unit");
									setMessageModal(true);
									setUnit(activeCanvas.constrains.data);
								} else {
									setCallTypeModal("compound");
									setMessageModal(true);
									setUnit(compound);
								}
							}}>
							<i className="fa fa-envelope"></i>
						</button>
						{!!propertyDetails?.sales_rep?.phone && (
							<ReactWhatsapp
								number={propertyDetails?.sales_rep?.phone}
								class="btn btnMessage"
								message="">
								<img src={whatsapp} alt="whatsapp" width="20" />
							</ReactWhatsapp>
						)}

						{/* Byu Now */}
						{activeCanvas?.constrains?.type === "unit" && (
							<>
								<button
									className="btn btnMessage text-center"
									style={{ marginLeft: "8px" }}
									onClick={(e) => {
										e.stopPropagation();
										interestHandler(activeCanvas.constrains?.id);
									}}>
									{isInterested(activeCanvas.constrains?.id) ? (
										<i className="fas fa-heart text-danger"></i>
									) : (
										<i className="far fa-heart text-danger"></i>
									)}
								</button>
								<button
									className="btn btn-primary text-center mx-2"
									onClick={(e) => {
										e.stopPropagation();
										toggleFullscreen();
										dispatch(appendFilters({ from: "interactive" }));
									}}>
									{t("Buy Now")}
								</button>
							</>
						)}
					</div>

					{activeCanvas?.constrains?.type === "unit" && (
						<div
							className="font-size-18 text-bold position-absolute mt-1"
							style={{
								fontWeight: "600",
								left: "50%",
							}}>
							{`${openImage + 1} / ${activeCanvas?.images?.length}`}
						</div>
					)}

					<div>
						<button
							className="btn btn-danger"
							onClick={() => {
								toggleFullscreen();
							}}>
							<i className="fas fa-times"></i> {t("close")}
						</button>
					</div>
				</Col>

				<Col className="active position-relative " md={12}>
					<div
						id="toolTip"
						className="p-0"
						style={{
							background: "none",
							height: toolTipData?.type === "building" ? "340px" : "365px",
						}}>
						{toolTipData?.type === "none" ? (
							<div className="comCard websitPages">
								{activeCardImg ? (
									<img src={activeCardImg} alt="activeCardImg" />
								) : (
									<img src={compoundImg} alt="compoundImg" />
								)}
								<div style={{ minHeight: "180px" }}>
									<CardText
										tag="h4"
										className="font-size-16  "
										style={{ color: "#3a3335", fontWeight: 800 }}>
										{toolTipData?.title}
									</CardText>
									<Row className="d-flex justify-content-between align-items-center m-0">
										<Col md={6} className="p-0 fw-bold mb-2">
											{t("developer")}
										</Col>
										<Col
											md={6}
											className="fw-bold d-flex justify-content-end p-0">
											{developer?.name[`${AuthData.lang}`]
												? developer?.name[`${AuthData.lang}`]
												: developer?.name?.en}
										</Col>
										{t("none hotspot")}
									</Row>
								</div>
							</div>
						) : toolTipData?.type === "building" ? (
							<div className="comCard websitPages">
								{activeCardImg ? (
									<img src={activeCardImg} alt="activeCardImg" />
								) : (
									<img src={compoundImg} alt="compoundImg" />
								)}

								{developer?.media?.path ? (
									<img src={developer.media.path} className="imgAbsolute" />
								) : (
									<img src={developerdImg} className="imgAbsolute" />
								)}
								<div style={{ minHeight: "180px" }}>
									<CardText
										tag="h4"
										className="font-size-16  "
										style={{ color: "#3a3335", fontWeight: 800 }}>
										{toolTipData?.data?.name[`${AuthData.lang}`]
											? toolTipData?.data?.name[`${AuthData.lang}`]
											: toolTipData?.data?.name?.en}
									</CardText>
									<Row className="px-2">
										<Col md={6} className="p-0 fw-bold mb-2">
											<span
												className="text-muted font-size-14 pe-2 "
												style={{ opacity: 0.4 }}>
												{t("starting from")}{" "}
											</span>
										</Col>
										<Col
											md={6}
											className="fw-bold d-flex justify-content-end p-0">
											<span className="font-size-16">
												{toCurrency(toolTipData?.data?.starting_from)}{" "}
												{currency?.currency_code}
											</span>
										</Col>
										<Col
											md={12}
											className="p-0 fw-bold mb-2"
											style={{ opacity: 0.4 }}>
											{toolTipData?.data?.installment
												? t("up to installment", {
														num: toolTipData?.data?.installment,
												  })
												: t("only cash")}
										</Col>
										<Col md={6} className="p-0 fw-bold">
											<span className="font-size-14 pe-2">
												{t("developer")}{" "}
											</span>
										</Col>
										<Col
											md={6}
											className="fw-bold d-flex justify-content-end p-0">
											<span className="font-size-14">
												{developer?.name[`${AuthData.lang}`]
													? developer?.name[`${AuthData.lang}`]
													: developer?.name?.en}
											</span>
										</Col>
										<div className="border-line"></div>
										<Col md={6} className="p-0 fw-bold">
											<span className="font-size-14 pe-2">
												{t("Available Units")}{" "}
											</span>
										</Col>
										<Col
											md={6}
											className="fw-bold d-flex justify-content-end p-0">
											<span className="font-size-14">{noAvailableUnit}</span>
										</Col>
										<div className="border-line"></div>
									</Row>

									{toolTipData?.data?.unit_types
										?.filter((obj, index, self) => {
											return index === self.findIndex((o) => o.en === obj.en);
										})
										?.map((unit, index) => {
											return (
												<Badge key={index} className="bgBadge font-size-12">
													{unit[`${AuthData.lang}`]
														? unit[`${AuthData.lang}`]
														: unit?.en}
												</Badge>
											);
										})}
								</div>
							</div>
						) : toolTipData?.type === "layer" ? (
							<div className="comCard websitPages">
								{activeCardImg ? (
									<img src={activeCardImg} alt="activeCardImg" />
								) : (
									<img src={compoundImg} alt="compoundImg" />
								)}

								{developer?.media?.path ? (
									<img src={developer.media.path} className="imgAbsolute" />
								) : (
									<img src={developerdImg} className="imgAbsolute" />
								)}
								<div style={{ minHeight: "180px" }}>
									<CardText
										tag="h4"
										className="font-size-16  "
										style={{ color: "#3a3335", fontWeight: 800 }}>
										{toolTipData?.label}
									</CardText>
									<Row className="px-2">
										<Col md={8} className="p-0 fw-bold">
											<span className="font-size-14 pe-2">
												{t("No. Available Units")}{" "}
											</span>
										</Col>
										<Col
											md={4}
											className="fw-bold d-flex justify-content-end p-0">
											<span className="font-size-14">
												{
													modeData?.images?.filter(
														(res) => res?.id == toolTipData?.idImage?.id
													)[0]?.shapes?.length
												}
											</span>
										</Col>
										<div className="border-line"></div>
										<Col md={6} className="p-0 fw-bold">
											<span className="font-size-14 pe-2">
												{t("Min Sizes")}{" "}
											</span>
										</Col>
										<Col
											md={6}
											className="fw-bold d-flex justify-content-end p-0">
											<span className="font-size-14">
												{Math?.min(...minSize)}
											</span>
											{/* <span className="font-size-14">{Math?.min(...modeData.images?.filter(img=> img?.id === toolTipData?.idImage?.id)[0]?.shapes?.map(shape=> shape.hotspot?.data?.size))}</span> */}
										</Col>
										<div className="border-line"></div>
										<Col md={6} className="p-0 fw-bold">
											<span className="text-muted font-size-14 pe-2">
												{t("starting from")}{" "}
											</span>
										</Col>
										<Col
											md={6}
											className="fw-bold d-flex justify-content-end p-0">
											<span className="font-size-16">
												{toCurrency(toolTipData?.data?.starting_from)}{" "}
												{currency?.currency_code}
											</span>
										</Col>
										<div className="border-line"></div>
										<Col
											md={12}
											className="p-0 fw-bold mb-2"
											style={{ opacity: 0.7 }}>
											{toolTipData?.data?.installment
												? t("up to installment", {
														num: toolTipData?.data?.installment,
												  })
												: t("only cash")}
										</Col>
									</Row>
								</div>
							</div>
						) : toolTipData?.type === "unit" ? (
							<div className="tooltip-card">
								{modeData.images?.filter(
									(img) => img.constrains?.id == toolTipData?.id
								)[0].images?.length > 0 ? (
									<img
										src={
											modeData.images?.filter(
												(img) => img.constrains?.id == toolTipData?.id
											)[0]?.images[0].path
										}
										className="tooltip-image"
										alt="unit"
									/>
								) : (
									<img
										src={compoundImg}
										className="tooltip-image"
										alt="compoundImg"
									/>
								)}
								{developer?.media?.path ? (
									<img src={developer.media.path} className="imgAbsolute" />
								) : (
									<img src={developerdImg} className="imgAbsolute" />
								)}
								<div className="tooltip-cardbody">
									<Badge className="bgBadgeResale  badgeAbsolute font-size-12">
										{toolTipData?.data?.unit_types[`${AuthData.lang}`]
											? toolTipData?.data?.unit_types[`${AuthData.lang}`]
											: toolTipData?.data?.unit_types?.en}
									</Badge>
									<div className="maxBodyHeight" style={{ height: "8rem" }}>
										<CardText
											tag="h4"
											className="font-size-16"
											style={{ color: "#3a3335", fontWeight: 800 }}>
											{toolTipData?.data?.name[`${AuthData.lang}`]
												? toolTipData?.data?.name[`${AuthData.lang}`]
												: toolTipData?.data?.name?.en}
										</CardText>
										<CardText tag="h4" className="mb-1">
											<span className="font-size-16">
												{toCurrency(toolTipData?.data?.starting_from)}{" "}
												{currency?.currency_code}
											</span>
										</CardText>
										<div className="d-flex ">
											<p className="w-100 text-black icon_container">
												<i className="fa me-1 fa-bed"></i>
												{toolTipData?.data?.bedrooms} {t("beds")}
											</p>
											<p className="w-100 text-black icon_container">
												<i className="fa me-1 fa-shower"></i>
												{toolTipData?.data?.bathrooms} {t("baths")}
											</p>
											<p className="w-100 text-black icon_container">
												<i className="fa me-1 fa-exchange-alt"></i>
												{parseInt(toolTipData?.data?.size).toFixed(0)}{" "}
												{t("sqm")}
											</p>
										</div>
										<p className="w-100 text-black icon_container">
											<i className="fa me-1 fa-home"></i> {t("floor number")}{" "}
											{toolTipData?.floor}
										</p>
										<p className="w-100 text-black my-0">
											<i className="fas me-1 fa-map-marker-alt"></i>
											{city[`${AuthData.lang}`]
												? city[`${AuthData.lang}`]
												: city?.en}
											,
											{address[`${AuthData.lang}`]
												? address[`${AuthData.lang}`]
												: address?.en}
											,
											{area[`${AuthData.lang}`]
												? area[`${AuthData.lang}`]
												: area?.en}
										</p>
									</div>
									<div className="d-flex mt-3 justify-content-between">
										{!!propertyDetails?.sales_rep?.phone && (
											<div className=" w-100">
												<button
													className="w-100 btn btnMessage text-center'"
													onClick={(e) => {
														e.stopPropagation();
														setCallModal(true);
														setCallTypeModal("unit");
														setPhone(propertyDetails?.sales_rep?.phone);
													}}>
													<i className="fas fa-phone-alt"></i> {t("call")}
												</button>
											</div>
										)}
										<div className=" w-100 mx-2">
											<button
												className="w-100 btn btnMessage text-center"
												onClick={(e) => {
													e.stopPropagation();
													setCallTypeModal("unit");
													setMessageModal(true);
													setUnit(toolTipData.data);
												}}>
												<i className="fa fa-envelope"></i>
											</button>
										</div>
										{interestLoading ? (
											<div className="w-100 d-flex justify-content-center pt-2">
												<Spinner size="sm" color="primary" />
											</div>
										) : (
											<div className="w-100">
												<button
													className="w-100 btn btnMessage text-center"
													onClick={(e) => {
														e.stopPropagation();
														interestHandler(toolTipData?.data?.id);
													}}>
													{isInterested(toolTipData?.data?.id) ? (
														<i className="fas fa-heart text-danger"></i>
													) : (
														<i className="far fa-heart text-danger"></i>
													)}
												</button>
											</div>
										)}
									</div>
									<div className="mt-2">
										<button
											className="btn btn-primary w-100 text-center"
											onClick={() => {
												toggleFullscreen();
												history.push(
													`/property-details/${toolTipData?.data?.id}`
												);
												dispatch(appendFilters({ from: "interactive" }));
											}}>
											{t("Buy Now")}
										</button>
									</div>
								</div>
							</div>
						) : null}
					</div>

					<div id="loader">
						<Spinner2></Spinner2>
					</div>
					<canvas id={`canvas`}></canvas>
				</Col>

				{activeCanvas?.constrains?.type === "unit" && (
					<div
						className="images-div"
						style={{
							position: "absolute",
							zIndex: "9999",
							background: "#FFF",
							overflow: "hidden",
							top: "52.7px",
							height: "calc(100vh - 52.7px)",
						}}>
						{openImage > 0 && (
							<button
								type="button"
								className="arrow-buttons"
								onClick={() => setOpenImage((prev) => prev - 1)}
								style={{ left: "20px" }}>
								<i
									className="fas fa-chevron-left fa-2x "
									style={{
										padding: "10px 15px",
										border: "1px solid",
										borderRadius: "50%",
									}}></i>
							</button>
						)}
						<div
							style={{ width: "80%", height: "97%" }}
							className="m-auto d-flex align-items-center justify-content-center">
							<img
								alt="image"
								src={activeCanvas?.images[openImage]?.path}
								style={{
									maxHeight: "100%",
									maxWidth: "100%",
								}}
							/>
						</div>
						{openImage < activeCanvas.images?.length - 1 && (
							<button
								onClick={() => setOpenImage((prev) => prev + 1)}
								className="arrow-buttons"
								style={{ right: "60px" }}>
								<i
									style={{
										padding: "10px 15px",
										border: "1px solid",
										borderRadius: "50%",
									}}
									className="fas fa-chevron-right fa-2x"></i>
							</button>
						)}
					</div>
				)}

				{callModal && (
					<CallModal
						modal={callModal}
						setModal={setCallModal}
						callTypeModal={callTypeModal}
						phone={phone}
					/>
				)}
				{messageModal && (
					<MessageModal
						modal={messageModal}
						setModal={setMessageModal}
						item={unit}
						type={callTypeModal}
					/>
				)}
			</Row>
		</>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};

export default UserMode;
